import { render, staticRenderFns } from "./RealWidget.vue?vue&type=template&id=3d9a613b&scoped=true&"
import script from "./RealWidget.vue?vue&type=script&lang=js&"
export * from "./RealWidget.vue?vue&type=script&lang=js&"
import style0 from "./RealWidget.vue?vue&type=style&index=0&id=3d9a613b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a613b",
  null
  
)

export default component.exports